module.exports = __webpack_public_path__ + "img/paginationleft-disabled.d2077bc8.svg";